import $ from "jquery";
import "../components/InfoSection";
import "../components/MarqueeSection";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let logoTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".villa-story__columns",
    start: "top 50%",
  },
});

logoTl.to(".logo__helper", {
  height: 0,
  duration: 1,
  ease: "none",
});
